import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { CarrierModel, ControlProperty, SourceSealModel } from '../../../../../../common/models';
import { LocalDateRangeModel } from '../../../../../models';
import { AllocationViewSealForm } from '../allocation-security';
import { AllocationViewActionCarrierForm } from '../allocation-view-action-carrier.model';
import { sealPictureControlValidatorForTruckSealData } from './allocation-seal-picture-control.validators';

export class AllocationViewSealPictureControlModel {
  carrier: CarrierModel;
  compartmentName: string;
  dangerousGoods: boolean;
  driverFirstName: string;
  driverLastName: string;
  driverPhone: string;
  freeTextCarrierName: string;
  hubId: number;
  remainingDrivingTime: number;
  sealPhotos: SealPhotosModel;
  serviceTime: LocalDateRangeModel;
  trailerPlate: string;
  truckId: number;
  truckPlate: string;
}

export class SealPhotosModel {
  truckSealData: SourceSealModel;
  trailerSealData: SourceSealModel;
}

export class AllocationViewSealPictureControlForm {
  constructor(
    model: AllocationViewSealPictureControlModel,
    fb: UntypedFormBuilder,
    public generalInformation: UntypedFormGroup = fb.group(
      new AllocationViewSealPictureControlGeneralInformationForm(model, fb),
    ),
    public sealPhotos: UntypedFormGroup = fb.group(new AllocationViewSealPhotosForm(model, fb), {
      validators: sealPictureControlValidatorForTruckSealData,
    }),
  ) {}
}

export class AllocationViewSealPictureControlGeneralInformationForm {
  constructor(
    model: AllocationViewSealPictureControlModel,
    fb: UntypedFormBuilder,
    public carrier: UntypedFormGroup = fb.group(new AllocationViewActionCarrierForm(model.carrier)),
    public freeTextCarrierName: ControlProperty<string> = [model.freeTextCarrierName, []],
    public compartmentName: ControlProperty<string> = [model.compartmentName, []],
    public dangerousGoods: ControlProperty<boolean> = model.dangerousGoods,
    public driverFirstName: ControlProperty<string> = model.driverFirstName,
    public driverLastName: ControlProperty<string> = model.driverLastName,
    public driverPhone: ControlProperty<string> = model.driverPhone,
    public hubId: ControlProperty<number> = model.hubId,
    public remainingDrivingTime: ControlProperty<number> = [model.remainingDrivingTime, []],
    public serviceTime: ControlProperty<LocalDateRangeModel> = [model.serviceTime, []],
    public trailerPlate: ControlProperty<string> = model.trailerPlate,
    public truckId: ControlProperty<number> = model.truckId,
    public truckPlate: ControlProperty<string> = model.truckPlate,
  ) {}
}

export class AllocationViewSealPhotosForm {
  constructor(
    model: AllocationViewSealPictureControlModel,
    fb: UntypedFormBuilder,
    public truckSealData: UntypedFormGroup = fb.group(new AllocationViewSealForm(model?.sealPhotos?.truckSealData)),
    public trailerSealData: UntypedFormGroup = fb.group(new AllocationViewSealForm(model?.sealPhotos?.trailerSealData)),
    public trailerPlate: ControlProperty<string> = model.trailerPlate,
  ) {}
}
